import { config as projectConfig } from '~/src/services/projects/config';
import { blockConfig } from '~/src/services/blocks/configs/blockConfig';
import { textConfig } from '~/src/services/blocks/configs/textConfig';
import { buttonConfig } from '~/src/services/blocks/configs/buttonConfig';
import { imageConfig } from '~/src/services/blocks/configs/imageConfig';
import { installmentPlanFormConfig } from '~/src/services/blocks/configs/installmentPlanFormConfig';
import { installmentTariffFormConfig } from '~/src/services/blocks/configs/installmentTariffFormConfig';
import { phoneFormConfig } from '~/src/services/blocks/configs/phoneFormConfig';
import { columnConfig } from '~/src/services/blocks/configs/columnConfig';
import { columnWithStylesConfig } from '~/src/services/blocks/configs/columnWithStylesConfig';
import { imageSectionConfig } from '~/src/services/blocks/configs/imageSectionConfig';
import { textWithoutContent } from '~/src/services/blocks/configs/textWithoutContent';
import { htmlTextConfig } from '~/src/services/blocks/configs/htmlTextConfig';
import { carouselImageConfig } from '~/src/services/blocks/configs/carouselImageConfig';
import { sliderImageConfig } from '~/src/services/blocks/configs/sliderImageConfig';
import { accordionConfig } from '~/src/services/blocks/configs/accordionConfig';
import { ageRestrictionConfig } from '~/src/services/blocks/configs/ageRestrictionConfig';
import { blockGridColumnConfig } from '~/src/services/blocks/configs/blockGridColumnConfig';
import { tabColumnConfig } from '~/src/services/blocks/configs/tabColumnConfig';

export interface IBlockType {
    label: string;
    value: string;
}

export interface IBlockTypes {
    [key: string]: Record<string, any>;
}

const blockConfigs: IBlockTypes = {
    project: projectConfig,
    block: blockConfig,
    text: textConfig,
    textWithoutContent,
    button: buttonConfig,
    image: imageConfig,
    installmentPlanForm: installmentPlanFormConfig,
    installmentTariffForm: installmentTariffFormConfig,
    column: columnConfig,
    accordionColumn: accordionConfig,
    ligalColumn: columnWithStylesConfig,
    imageSection: imageSectionConfig,
    rte: htmlTextConfig,
    phoneForm: phoneFormConfig,
    carouselImage: carouselImageConfig,
    sliderImage: sliderImageConfig,
    ageRestriction: ageRestrictionConfig,
    blockGridColumn: blockGridColumnConfig,
    tabColumn: tabColumnConfig,
};

export default blockConfigs;
